export default __webpack_public_path__ + "static/media/Zone-4-Master-Plan-Type-E.0371a1e3.png";